import {EventEmitter, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  onMarkAsRead = new EventEmitter<number[]>();
}
